<template>
	<v-dialog v-model="dialog" persistent max-width="600px">
		<v-card class="text-xs-left">
			<v-form v-model="valid" lazy-validation>
				<v-toolbar flat dense cad class="warning" dark>
					<v-toolbar-title class="subheading">Deactivate Company Account</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<p class="mb-4">Are you sure you want to cancel your current plan? You will still have full access to all features and services until the end of your current billing period.</p>
					<h4 class="mb-2">Important:</h4>
					<ul>
						<li><strong>Billing:</strong> You won't be charged again after the cancellation, but you can continue to use the system until your billing period ends.</li>
						<li><strong>Free Trial:</strong> If you're still on a free trial, you'll retain full access until the trial period ends.</li>
						<li><strong>Data Retention:</strong> Your account and data will remain intact should you choose to reactivate before the end of your billing period.</li>
					</ul>
					<div class="mt-4 mb-2">Please type <strong>"CONFIRM"</strong> below to deactivate your account:</div>
					<v-text-field v-model="confirmationText" label="Type CONFIRM to proceed" required :rules="[v => !!v || 'Confirmation is required', v => v === 'CONFIRM' || 'You must type CONFIRM DELETE to continue']"></v-text-field>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeDialog">Close</v-btn>
					<v-btn flat :disabled="confirmationText !== 'CONFIRM' || isCancelling" @click="submit" color="primary" :loading="isCancelling">Cancel Plan</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				confirmationText: '',
				valid: false,
				isCancelling: false
			};
		},
		methods: {
			closeDialog() {
				this.$emit('close');
			},
			submit() {},
			async submit() {
				if (this.confirmationText !== 'CONFIRM') return;
				this.isCancelling = true;

				const response = await this.$store.dispatch('productPlans/cancelPlan');
				if (response.status === 200) {
					this.closeDialog();
				}

				this.isCancelling = false;
			}
		}
	};
</script>

<style></style>
